<template>

  <div class="login-wrapper register">
    <container>

      <div class="col-xl-8 offset-xl-2 pad0">
        <div class="login-gen">
          <div class="login-box register-box col-xl-6">
            <row class="tabs">
              <div class="tabs__item"
                   v-for="tab in tabs" :key="tab.id"
                   :class="{ 'active-tab' : tab.active }"
                   @click="tabShow(tab.id)">
                <img class="tabs__item-img" :src="tab.icon" alt="">
                <span class="tabs__item-link">{{ tab.title }}</span>
              </div>
            </row>

            <div class="register-box_input">

              <v-input placeholder="Adınız Soyadınız"/>
              <v-input placeholder="Üniversite Adı"/>
              <v-input placeholder="Fakülte Adı"/>
              <v-input placeholder="Telefon No"/>
            </div>
          </div>
          <div class="register-box__info col-xl-6">
            <div class="or blue">
              <p class="or__title-blue">LOGIN INFORMATION</p>
            </div>
            <v-input placeholder="E-mail Adresi"/>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <v-input placeholder="Şifre" :type="password"/>
              </div>

              <div class="col-xs-12 col-md-6">
                <v-input placeholder="Şifre Tekrar"/>
              </div>
            </div>

            <div class="check-wrapper smart-map">
              <div class="check-wrapper__item">
                <label class="container2" style="width: 100%;">
                  <div class="check"><input type="checkbox" style="width: auto;"><span class="checkmark"></span><span
                    class="name"> Tüm duyuru ve kampanyalardan ticari e-ileti yoluyla haberdar olmak istiyorum. </span>
                  </div>
                </label>
              </div>

              <div class="check-wrapper__item">
                <label class="container2" style="width: 100%;">
                  <div class="check"><input type="checkbox" style="    width: auto;"><span
                    class="checkmark"></span><span class="name"> Tüm duyuru ve kampanyalardan ticari e-ileti yoluyla haberdar olmak istiyorum. </span>
                  </div>
                </label>
              </div>

            </div>

            <v-button
              class="green fw shadow-none login-box__submit"
              title="HEMEN ÜYE OL"
            />

            <div class="or">
              <p class="or__title">VEYA</p>
            </div>
            <v-button
              class="gray fw shadow-none login-box__submit"
              title="LOGIN WITH FACEBOOK"
            />

            <div class="login-box__bottom">
              <p class="login-box__bottom-text">You already have a holywoodskyline account ?</p>
              <router-link to="/uye-ol" class="button button--more color-light-green"><span
                class="button__wrp"><span class="button__txt">
    LOGIN NOW
  </span><span class="button__icon"><svg class="icon"><use
                xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link>

              <div class="login-box__dorm">

              </div>
            </div>
          </div>

          <div class="register-info">
            <div class="about-info__item item-register">
              <div class="about-info__item--left  item-register--left">
                <div class="about-info__item_img item-register_img"><img src="/img/view.b6193a4c.svg" alt=""></div>
              </div>

              <div class="about-info__item--right  item-register--right">
                <div class="about-info__number"><strong>4.233.502</strong>
                  <p>View</p></div>
                <div class="about-info__item_text"><p>holywoodskyline.com, çalışan
                  itibariyle üniversiteden mezun.
                </p></div>
              </div>
            </div>

            <div class="about-info__item item-register">
              <div class="about-info__item--left item-register--left">
                <div class="about-info__item_img item-register_img"><img src="/img/dom.080e8c0e.svg" alt=""></div>
              </div>

              <div class="about-info__item--right item-register--right">
                <div class="about-info__number"><strong>45,100</strong>
                  <p>Active Movie</p></div>
                <div class="about-info__item_text"><p>holywoodskyline.com, çalışan
                  itibariyle üniversiteden mezun.
                </p></div>
              </div>
            </div>

            <div class="about-info__item item-register">
              <div class="about-info__item--left item-register--left">
                <div class="about-info__item_img item-register_img"><img src="/img/visitor.9441c916.svg" alt=""></div>
              </div>

              <div class="about-info__item--right item-register--right">
                <div class="about-info__number"><strong>2.573.648</strong>
                  <p>Anually Visitor</p></div>
                <div class="about-info__item_text"><p>holywoodskyline.com, çalışan
                  itibariyle üniversiteden mezun.
                </p></div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </container>
  </div>
</template>

<script>
export default {
  name: 'RegisterDorm',
  data () {
    return {
      tabs: [
        {
          id: 0,
          title: 'YURT KAYIT',
          icon: require('@/assets/img/register-student.svg'),
          active: true
        }
      ]
    }
  },
  methods: {
    tabShow (id) {
      this.tabs.forEach((item) => {
        item.active = false
      })
      this.tabs[ id ].active = true
    }
  }
}

</script>

<style lang="scss">
  @import "../assets/scss/components/register";

  .wrapper {
    padding-bottom: 275px;
  }

</style>
